import React from 'react';
import { useDispatch } from "react-redux";
import { WithStartOfWeek } from '@shared/hooks/WithStartOfWeek';
import { startEditingWhereabouts } from '@features/whereabouts/store/editMovements.duck';
import { isDateBefore } from '@shared/utils/DateUtils';
import moment from "moment";
import { OutlineButton } from "../../../../atoms/buttons/OutlineButton";
import { WhereaboutsGroupType } from '@features/whereabouts/models/movements.models';
import { ButtonSize } from '@shared/ui/atoms/buttons/ButtonStyling';

export function SetWhereaboutsButton(props: Props) {
  const {isEditing, userId, isCurrentUser, className} = props;
  const dispatch = useDispatch();
  const startOfWeek = WithStartOfWeek();

  if (isEditing || !isCurrentUser) {
    return null;
  }

  const onClick = () => {
    const activeDate = isDateBefore(startOfWeek, moment()) ? moment() : startOfWeek;
    dispatch(startEditingWhereabouts({userId: userId, date: activeDate.clone(), groupId: WhereaboutsGroupType.Users}));
  }

  const btnText = 'team-view.set-whereabouts';
  return (
    <OutlineButton className={`wallchartRow__editButton ${className ?? ''}`.trim()}
                   dataTest="set-whereabouts-btn"
                   size={ButtonSize.Small}
                   text={btnText} click={onClick}/>
  )
}

interface Props {
  className?: string;
  userId: string;
  isCurrentUser: boolean;
  isEditing: boolean;
}
